import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { CustomerIdentificationLogModel } from 'Pages/logs'

interface CustomerIdentificationState {
	data: ResponseCatalog<CustomerIdentificationLogModel>
	requestParams: RequestParams
}

const initialState: CustomerIdentificationState = {
	data: new ResponseCatalog<CustomerIdentificationLogModel>(),
	requestParams: new RequestParams(),
}

export namespace CustomerIdentificationLogsNS {
	export type GetAll = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: () => void
		errorCallback?: (errors?: unknown) => void
	}>
	export type SetAll = PayloadAction<ResponseCatalog<CustomerIdentificationLogModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type ClearAll = PayloadAction
}

export const customerIdentificationSlice = createSlice({
	name: 'customerIdentification',
	initialState,
	reducers: {
		getAll: (state, action: CustomerIdentificationLogsNS.GetAll) => {},
		setAll: (state, action: CustomerIdentificationLogsNS.SetAll) => {
			state.data = action.payload
		},
		setRequestParams: (state, action: CustomerIdentificationLogsNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state, action: CustomerIdentificationLogsNS.ClearAll) => {
			state.data = new ResponseCatalog<CustomerIdentificationLogModel>()
			state.requestParams = new RequestParams()
		},
	},
})
